<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">用户匹配卡相关操作</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="6">
        <el-input v-model="rid" placeholder="请输入rid"></el-input>
      </el-col>
      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai" :loading="login1">
          查询
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        @row-click="list_for = true"
        :data="dayChatDetailData"
        v-loading="login1"
        stripe
        border
      >
        <el-table-column prop="rid" label="用户id" align="center">
        </el-table-column>
        <el-table-column prop="totalUsed" label="总使用" align="center">
        </el-table-column>
        <el-table-column prop="totalReceive" label="总领取" align="center">
        </el-table-column>
        <el-table-column prop="totalExpired" label="总失效" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="song_(scope.row)" size="small"
              >赠送</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-table
        v-if="list_for"
        :data="dayChatDetailData_"
        v-loading="login1"
        stripe
        border
      >
        <el-table-column prop="receiveNums" label="领取数量" align="center">
        </el-table-column>
        <el-table-column prop="expireTime" label="失效时间戳" align="center">
          <template slot-scope="scope">
            {{ format_(scope.row.expireTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="sceneId" label="赠送场景" align="center">
        </el-table-column>
        <el-table-column prop="ctime" label="创建时间戳" align="center">
          <template slot-scope="scope">
            {{ format_(scope.row.ctime) }}
          </template>
        </el-table-column>
        <el-table-column prop="nums" label="剩余数量" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="update(scope.row)" size="small"
              >更新</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-date-picker
        v-if="son"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="activity_time"
        type="datetime"
        align="right"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <div v-if="!son">
        <div>
          num:
          <el-input
            v-model="list_.num"
            style="width:120px"
            placeholder="请输入num"
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="son" @click="update_">确 定</el-button>
        <el-button type="primary" v-if="!son" @click="song">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        class="pagination"
      ></el-pagination>
    </el-row> -->
  </el-card>
</template>

<script>
// import download from '@/utils/download.js'

// import { datainfor } from '@/utils/formdata.js'
export default {
  data () {
    return {
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      rid: '',
      // 通话日期
      retainedOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],
      dayChatDetailData_: [],
      list_for: false,
      dialogVisible: false,
      activity_time: '',
      itemId: '',
      list_: {
        rid: '',
        num: ''
      },
      son: false
    }
  },
  created () {},
  methods: {
    handleClose (done) {
     
          done()
       
    },
    // 查询列表
    async getDayChatDetai () {
      this.login1 = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.items_list,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          rid: this.rid
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)

      this.dayChatDetailData = [res.data.totalData]
      this.dayChatDetailData_ = res.data.list
      this.list_for = false
      // this.total = res.data.total
    },
    async song () {
      this.login1 = true
      const { data: res } = await this.$axios({
        type: 'GET',
        url: this.$store.getters.path.items_add,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          rid: this.list_.rid,
          num: this.list_.num
        }
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.$message.success(res.msg)
      this.dialogVisible = false
    },
    async song_ (row) {
      this.son = false
      this.dialogVisible = true
      this.list_.rid = row.rid
    },
    update (row) {
      this.dialogVisible = true
      this.son = true
      this.itemId = row.itemId
      this.activity_time = this.format_(row.expireTime)
    },
    async update_ () {
      let url =
        this.$store.getters.path.expire_time +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = {
        itemId: this.itemId,
        dateTime: this.activity_time
      }
      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.dialogVisible = false
      this.getDayChatDetai()
      this.list_for = true
    },
    format_ (data) {
      let date = new Date((data) * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    }
    // 分页
    // handleCurrentChange () {
    //   this.getDayChatDetai()
    // }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
</style>
